import React, { FC } from 'react';

import styles from './styles.module.css';

export const Header: FC = () => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>Zone</div>
      <div className={styles.title}>Count</div>
    </div>
  );
};
